import request from '@/api/request'
import api from '@/api/api'
export const getMenu = (params) => {
    return request.post(api.getMenu, params)
}


// WEBPACK FOOTER //
// ./src/api/takeoutQuery.js